// extracted by mini-css-extract-plugin
export default {"row":"E7Oq_TfjnwRgEWBz6YNZ"};